module.exports = __webpack_public_path__ + "img/default_preview.fc475ab.png";